import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { removeUserToken } from "../../redux/reducer/auth.reducer";
import { notifyAuthChange } from "../../helpers/storageHelper";
import NavbarAccountMenu from "./NavbarAccountMenu";
import NavbarDate from "./NavbarDate";

const NavbarNavigationItems = () => {
  const dispatch = useAppDispatch();
  const { username, email_client } = useAppSelector((state) => state.user.data);

  return (
    <div className="flex min-w-0 flex-1 items-center justify-end gap-1 sm:gap-3">
      <div className="flex min-w-0 flex-1 justify-center">
        <NavbarDate />
      </div>
      <NavbarAccountMenu
        username={username}
        email={email_client}
        onLogout={() => {
          dispatch(removeUserToken());
          notifyAuthChange("logout");
        }}
      />
    </div>
  );
};

export default NavbarNavigationItems;
